import React from "react"

export default function Form({children,onSubmit=()=>{}}) {

    return <form className="space-y-4" onSubmit={onSubmit}>
        {children}
    </form>
};